import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { requireOwnNotification } from '../server/notification-access.js';

/** Marks the caller's own notification as read. Idempotent — the first timestamp wins. */
export const markNotificationRead = registerMutation({
  type: () => Boolean,
  operationName: 'markNotificationRead',
  resolve: (notificationID: string) => {
    return async () => {
      const { collection, notification } = await requireOwnNotification(notificationID);
      if (notification.readAt) return true;
      await collection.updateOne({ _id: notificationID }, { $set: { readAt: new Date(), updatedAt: new Date() } });
      return true;
    };
  },
  params: [{ name: 'notificationID', type: () => String }],
});
